/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { space, SpaceProps } from 'styles/styled'

export const StyledGroup = styled(({ mb, mt, ...rest }) => (
  <div {...rest} />
))<SpaceProps>`
  ${space}
`
